import React, {  useEffect, useState } from "react";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import Pagination from "../../components/pageProps/shopPage/Pagination";
import ProductBanner from "../../components/pageProps/shopPage/ProductBanner";
import ShopSideNav from "../../components/pageProps/shopPage/ShopSideNav";
import { getNecklaceProductData } from "../../api/Api";
import { bangle, bombayNecklesList, brasletList, chain, dollar, earrings, fancyStudsList, jimikiDropsEaringStudsList, machineChainList, necklace, ringList, studList } from "../../constants";

const Shop = () => {
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const [data, setData] = useState([]);

  const itemsPerPageFromBanner = (itemsPerPage) => {
    setItemsPerPage(itemsPerPage);
  };
  const [selectedCategory, setSelectedCategory] = useState("Necklace");
  const loadData = () => {
    setLoading(true);

    getNecklaceProductData("orgData@gmail.com", selectedCategory)

      .then((res) => {
        
        //setData(responseData);

        // let allItems = [...necklace, ...earrings, ...chain, ...dollar, ...bangle, ...ringList, ...bombayNecklesList, ...studList, ...fanceDollarList, ...jimikiDropsEaringStudsList, ...machineChainList, ...fancyStudsList, ...brasletList];
        // // Update `bangle` array with response data


        // setData(allItems);
        const retriveData = retrieveAndMergeCategory(selectedCategory, res.data);
        setData(retriveData);

      })
      .catch((error) => {
        if (error.message) {
          console.error("Error message:", error.message);
        } else {
          console.error("Sorry! Something went wrong.");
        }
      })
      .finally(() => {
        setLoading(false); // Ensures loading is turned off after the request completes
      });
  };
  useEffect(() => {
    loadData();
  }, [selectedCategory, data]);
  
  const retrieveAndMergeCategory = (selectedCategory, data) => {
    if (selectedCategory && selectedCategory !== "All") {
      if (selectedCategory === "Necklace") {
        data.forEach((responseItem) => {
          const bangleItem = necklace.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return necklace;
      } else if (selectedCategory === "Earring") {
        data.forEach((responseItem) => {
          const bangleItem = earrings.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return earrings;
      } else if (selectedCategory === "Ring") {
        data.forEach((responseItem) => {
          const bangleItem = ringList.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return ringList;
      } else if (selectedCategory === "Bangle") {
        data.forEach((responseItem) => {
          const bangleItem = bangle.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return bangle;
      } else if (selectedCategory === "Chain") {
        data.forEach((responseItem) => {
          const bangleItem = chain.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return chain;
      } else if (selectedCategory === "Dollar") {
        data.forEach((responseItem) => {
          const bangleItem = dollar.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return dollar;
      }
      else if (selectedCategory === "Stud") {
        data.forEach((responseItem) => {
          const bangleItem = studList.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return studList;
      }
      else if (selectedCategory === "BombayNeckles") {
        data.forEach((responseItem) => {
          const bangleItem = bombayNecklesList.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return bombayNecklesList;
      }
      else if (selectedCategory === "Machine chain") {
        data.forEach((responseItem) => {
          const bangleItem = machineChainList.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return machineChainList;
      }
      else if (selectedCategory === "FancyStuds") {
        data.forEach((responseItem) => {
          const bangleItem = fancyStudsList.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return fancyStudsList;
      }
      else if (selectedCategory === "Braslet") {
        data.forEach((responseItem) => {
          const bangleItem = brasletList.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return brasletList;
      }
      else if (selectedCategory === "JimikiDropsEaringStuds") {
        data.forEach((responseItem) => {
          const bangleItem = jimikiDropsEaringStudsList.find(item => item._id === responseItem._id);
          if (bangleItem) {
            bangleItem.des = responseItem.des;
            bangleItem.price = responseItem.price;
            bangleItem.productName = responseItem.productName;
            bangleItem.wastage = responseItem.wastage;
            bangleItem.weight = responseItem.weight;
            bangleItem.goldRateWhileOnboard = responseItem.goldRateWhileOnboard;
            bangleItem.onboardDate = responseItem.onboardDate;
            bangleItem.designName = responseItem.designName;
            bangleItem.stockType = responseItem.stockType;
            bangleItem.pgjWastage = responseItem.pgjWastage;
          }
        });
        return jimikiDropsEaringStudsList;
      }
      // let allItems = [...necklace, ...earrings, ...chain, ...dollar, ...bangle, ...ringList, ...bombayNecklesList, ...studList, ...fanceDollarList, ...jimikiDropsEaringStudsList, ...machineChainList, ...fancyStudsList, ...brasletList];
      // return allItems;
      // return paginationItems;
    }
  }

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="Products" />
      {/* ================= Products Start here =================== */}
      <div className="w-full h-full flex pb-20 gap-10">
        <div className="w-[20%] lgl:w-[25%] hidden mdl:inline-flex h-full">
          <ShopSideNav categorySelect={setSelectedCategory} />
        </div>
        <div className="w-full mdl:w-[80%] lgl:w-[75%] h-full flex flex-col gap-10">
          <ProductBanner itemsPerPageFromBanner={itemsPerPageFromBanner} />
          <Pagination itemsPerPage={itemsPerPage} selectedCategory={selectedCategory} data={data} />
        </div>
      </div>
      {/* ================= Products End here ===================== */}
    </div>
  );
};

export default Shop;
